import { useState } from "react";
import { TabsContext } from "./TabsContext";

export function TabsProvider({
  children,
  defaultTab,
  onBlur,
  onTabChange,
  unmount,
  value,
}: {
  children: React.ReactNode;
  defaultTab?: string;
  onBlur?: (e: React.FocusEvent<HTMLButtonElement>) => void;
  onTabChange?: (value: string) => void;
  unmount?: boolean;
  value?: string;
}) {
  const [trigger, setTrigger] = useState<string>(value ?? defaultTab ?? "");

  return (
    <TabsContext.Provider
      value={{
        activeTab: value ?? trigger,
        onBlur,
        setActiveTab: (tab: string) => {
          setTrigger(tab);
          onTabChange?.(tab);
        },
        unmount,
      }}
    >
      {children}
    </TabsContext.Provider>
  );
}
